import styled from "@mui/material/styles/styled";

const TimestampChip = styled("span")(({ theme }) => ({
  backgroundColor: theme.palette.shades.ghost[400],
  borderRadius: "8px",
  fontFamily: theme.typography.fontFamilySecondary,
  fontSize: "0.75rem",
  color: theme.palette.shades.neutral[500],
  padding: "1px 4px",
  display: "inline",
  height: "17px",
  lineHeight: 16 / 12,
}));

export default TimestampChip;
